export default __webpack_public_path__ + "static/media/kotak.4e06bae7.png";